var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"terminal-import"},[_c('transition',{attrs:{"name":"fade-transform","mode":"out-in"}},[_c(_vm.dynamComp,{tag:"component",attrs:{"detailInfo":_vm.rowDetail},on:{"goto":_vm.goInfo,"goback":_vm.handleBack}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }